const PAYMENT_METHODS = Object.freeze({
  ACH: 'ACH',
  DEBIT_CREDIT_CARD: 'CREDIT_DEBIT_CARD'
})

export default PAYMENT_METHODS



// WEBPACK FOOTER //
// ./src/constants/registration/paymentMethods.js